import { Box, Button, Divider, Flex, Text } from "@chakra-ui/react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Children } from "react";
import { useSearchParams } from "react-router-dom";
import { gotoFilteredQuestionList } from "./AIDashboard/AIDashboard";
import { useNavigate } from "react-router-dom";

/**
 * A chunky number with a title and an arrow to indicate a clickable link
 */
export function DashboardNumber({ title, value, unit, onClick, titlePosition: textPosition = "center" }) {
  if (value === 0) onClick = null; // nothing to click through to
  return (
    <Flex
      direction="column"
      flex="1"
      pl="10%"
      as={Button}
      variant="unstyled"
      onClick={onClick}
      cursor={onClick ? "pointer" : "default"}
    >
      <Text alignSelf={textPosition} fontSize="heading.s" fontWeight="bold">
        {title}
      </Text>
      <Flex align="center" alignSelf={textPosition}>
        <Text fontSize="heading.4xl" fontWeight="bold">
          {value} 
        </Text>
		{unit && <Text fontSize="body.s" opacity={0.8} ml={2} mt={1}>{unit}</Text>}
        {onClick && <ArrowUpRight size={32} />}
      </Flex>
    </Flex>
  );
}

const RequirementsCard = ({ numOwned = 0, numAssigned = 0, email }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleClick = (filterValue) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("q", filterValue);
    gotoFilteredQuestionList(navigate, null, null, newParams);
  };

  return (
    <Box
      bg="lime"
      borderRadius="lg"
      // boxShadow="lg"
      borderColor="gray.200"
      w="100%"
      p={6}
      display="flex"
      flexDirection="column"
      color="darkTeal"
    >
      {/* Header - Left Aligned */}
      <Box textAlign="left">
        <Text fontSize="heading.m" fontWeight="bold">
          Requirements
        </Text>
        <Text fontSize="body.s" opacity={0.8} mt={1}>
          You are responsible and/or accountable for these requirements
        </Text>
      </Box>

      {/* Centered Numbers Section */}
      <Flex flex={1} align="center" justify="center" mt={4} w="100%" minH="120px">
        {/* Owner Section (Equal Width) */}
        <DashboardNumber title="Owner" value={numOwned} onClick={() => handleClick(`owner:${email}`)} />

        {/* Divider in the Center */}
        <Divider orientation="vertical" height="100%" borderColor="darkTeal" mx={2} />

        {/* Assignee Section (Equal Width) */}
        <DashboardNumber title="Assignee" value={numAssigned} onClick={() => handleClick(`assignees:${email}`)} />
      </Flex>
    </Box>
  );
};

export default RequirementsCard;
